// Русские склонения количественных существительных (день/дня/дней и т.п.)

export type RuPluralForms = readonly [one: string, few: string, many: string]

/**
 * Выбирает нужную форму слова по числу согласно правилам русского языка.
 *
 * @example pluralizeRu(1, ['день', 'дня', 'дней']) // 'день'
 * @example pluralizeRu(3, ['день', 'дня', 'дней']) // 'дня'
 * @example pluralizeRu(11, ['день', 'дня', 'дней']) // 'дней'
 */
export function pluralizeRu(count: number, forms: RuPluralForms): string {
  const absCount = Math.abs(Math.trunc(count)) % 100
  const lastDigit = absCount % 10

  if (absCount >= 11 && absCount <= 14) return forms[2]
  if (lastDigit === 1) return forms[0]
  if (lastDigit >= 2 && lastDigit <= 4) return forms[1]
  return forms[2]
}

/** «3 дня», «11 дней», «21 день» */
export function pluralizeWithCount(count: number, forms: RuPluralForms): string {
  return `${count} ${pluralizeRu(count, forms)}`
}

export const DAY_FORMS: RuPluralForms = ['день', 'дня', 'дней']
export const MINUTE_FORMS: RuPluralForms = ['минута', 'минуты', 'минут']
export const HOUR_FORMS: RuPluralForms = ['час', 'часа', 'часов']
export const YEAR_FORMS: RuPluralForms = ['год', 'года', 'лет']
/** Счётчик под сбываемостью. Раздел называется «Предсказание дня» — считаем предсказания. */
export const FORECAST_FORMS: RuPluralForms = ['предсказание', 'предсказания', 'предсказаний']
/** Родительный падеж — «из 1 связи», «из 2 связей». */
export const LINK_GENITIVE_FORMS: RuPluralForms = ['связи', 'связей', 'связей']
/** Именительный — «6 связей» без знаменателя, когда уз больше лимита (гостевые узы слот не тратят). */
export const LINK_FORMS: RuPluralForms = ['связь', 'связи', 'связей']
/** «осталось 3 лучика» — счётчик дневного лимита. */
export const RAY_FORMS: RuPluralForms = ['лучик', 'лучика', 'лучиков']
